import {UserJourney, UserJourneyAndAttributes} from "../http/protocol";
import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";

export enum UserJourneyActionTypes {
    REQUEST = "@journey/request",
    RESPONSE = "@journey/response",
    ERROR = "@journey/error"
}
export type UserJourneyAction =
    | { type : UserJourneyActionTypes.REQUEST }
    | { type : UserJourneyActionTypes.RESPONSE, journey : UserJourneyAndAttributes }
    | { type : UserJourneyActionTypes.ERROR };


export function fetchJourneys(){
    return (dispatch : Dispatch) => {
        dispatch({ type : UserJourneyActionTypes.REQUEST });
        getContainer().getUserService().fetchUserJourney().then((r)=>{
            dispatch({ type : UserJourneyActionTypes.RESPONSE, journey : r });
        }).catch((e)=>{
            console.log("error fetching journey", e);
            dispatch({ type: UserJourneyActionTypes.ERROR });
        })
    }
}